const {
  keysSortedByValueDescriptors
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');
const {
  getFormContent
} = require('../lib/getFormContent');

/**
  * @function evalute - evaluate selectionTitlesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = source2 => evaluateSource(source2, content, parentContentPath, transientContext, nativeFunctions);
  const selection = await sourceEvaluator(source.value);
  if (selection === undefined) {
    return undefined;
  }
  const pedigreeSeparator = await sourceEvaluator(source.pedigreeSeparator);
  const leaves = [];
  const traverse = async (subtree, ancestors) => {
    const sortDescriptors = [{
      path: '_created',
      ascending: true
    }, {
      path: 'title',
      ascending: true
    }];
    const keys = keysSortedByValueDescriptors(subtree, sortDescriptors);
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      let value = subtree[key];
      const {
        children,
        _formRef: newFormID
      } = value;
      if (newFormID !== undefined) {
        // eslint-disable-next-line no-await-in-loop
        value = await getFormContent(newFormID, content, parentContentPath, transientContext, nativeFunctions);
      }
      const {
        title = '?'
      } = value;
      const current = [...ancestors, title];
      if (children === undefined) {
        leaves.push(pedigreeSeparator === undefined ? title : current.join(pedigreeSeparator));
      } else {
        // eslint-disable-next-line no-await-in-loop
        await traverse(children, current);
      }
    }
  };
  await traverse(selection, []);
  return leaves;
};
module.exports = {
  evaluate
};